import React from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';

import { AssignmentEditRoute } from './AssignmentEditRoute';
import { AssignmentApplyStrategyRoute } from '~/borrower/routes/assignment/AssignmentApplyStrategyRoute';
import { AssignmentEditByCSVRoute } from '~/borrower/routes/assignment/AssignmentEditByCSVRoute';
import { AssignmentSelectImplementationRoute } from '~/borrower/routes/assignment/AssignmentSelectImplementationRoute';
import { AssignmentSelectStrategyRoute } from '~/borrower/routes/assignment/AssignmentSelectStrategyRoute';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { LatestAssignmentPipelineRunMetadataForImplementationProvider } from '~/packages/loanProduct/hooks/LatestAssignmentPipelineRunMetadataForImplementationProvider';
import { AssignmentDashboardContainer } from '~/packages/loanProduct/ui/v2/AssignmentSummary/AssignmentDashboard';

export const AssignmentRouter = () => {
  const flags = useFeatureFlags();

  return (
    <Routes>
      {flags.assignByIndividualReceivable && (
        <Route path="/edit" element={<AssignmentEditRoute />} />
      )}

      <Route
        path="/:implementationId/*"
        element={
          <LatestAssignmentPipelineRunMetadataForImplementationProvider>
            <Routes>
              <Route
                path="/summary/*"
                element={<AssignmentDashboardContainer />}
              />

              <Route
                path="/edit-by-csv"
                element={<AssignmentEditByCSVRoute />}
              />
              <Route
                path="/strategy"
                element={<AssignmentSelectStrategyRoute />}
              />

              <Route
                path="/strategy/:strategyId/apply"
                element={<AssignmentApplyStrategyRoute />}
              />
            </Routes>
          </LatestAssignmentPipelineRunMetadataForImplementationProvider>
        }
      />
      <Route
        path="/select-group"
        element={<AssignmentSelectImplementationRoute />}
      />
      <Route path="/*" element={<Navigate to="/assignments/select-group" />} />
    </Routes>
  );
};
